const mediaItems = [
  {
    title: '独家对话：圈内资深经纪人爆料行业内幕',
    type: '视频访谈',
    duration: '12:38',
    views: '28.6万',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interview%20studio%20setup%20with%20warm%20lighting%2C%20microphone%20and%20camera%20equipment%2C%20editorial%20atmosphere%2C%20documentary%20style%2C%20no%20faces%2C%20no%20text&width=600&height=340&seq=media-1-m1&orientation=landscape',
  },
  {
    title: '五分钟看懂某综艺本季所有争议焦点',
    type: '解说盘点',
    duration: '05:22',
    views: '41.3万',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20video%20editing%20timeline%20with%20warm%20amber%20and%20coral%20accents%2C%20modern%20media%20production%20style%2C%20abstract%20visualization%2C%20no%20faces%2C%20no%20text&width=600&height=340&seq=media-2-m2&orientation=landscape',
  },
  {
    title: '明星街拍穿搭全解析：素人也能复刻',
    type: '时尚解析',
    duration: '08:15',
    views: '19.7万',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20styling%20flat%20lay%20with%20warm%20neutral%20tones%2C%20accessories%20and%20fabric%20textures%2C%20editorial%20magazine%20style%2C%20minimalist%20composition%2C%20no%20faces%2C%20no%20text&width=600&height=340&seq=media-3-m3&orientation=landscape',
  },
  {
    title: '年度十大最热BGM背后的故事',
    type: '音乐故事',
    duration: '10:45',
    views: '35.2万',
    image: 'https://readdy.ai/api/search-image?query=Vinyl%20records%20and%20headphones%20with%20warm%20golden%20lighting%2C%20music%20production%20atmosphere%2C%20vintage%20modern%20fusion%20style%2C%20editorial%20photography%2C%20no%20faces%2C%20no%20text&width=600&height=340&seq=media-4-m4&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-secondary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            视频专区
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden cursor-pointer hover:border-secondary-200/60 transition-colors"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-mono whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-600 font-medium whitespace-nowrap">{item.type}</span>
                  <span className="whitespace-nowrap">{item.views} 播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}